<template>
  <div class="">
    <!-- 子页面banner -->
    <div class="x-banner">
      <BANNER></BANNER>
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <!-- 科室导航 -->
    <div class="container-width x-medical">
      <div class="title">科室导航</div>
      <!-- 科室  -->
      <section class="department-navigation">
        <div class="container-width">
          <ul class="ulPartList">
            <li class="li" v-for="(item, index) in list" :key="index">
              <a @click="showDialog(item)" class="wh_dot"> {{ item.name }}</a>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
      </section>
    </div>
    <!-- 国家临床重点专科 特色  -->
    <section class="medical-treatment blue-bg">
      <div class="container-width">
        <div class="item">
          <div class="line-one">
            <router-link to="/ylts/zhuanke">
              <p>国家临床重点专科</p>
              <p>NATIONAL KEY CLINICAL SPECIALTY</p>
            </router-link>
          </div>
          <p class="line-two">
            <router-link to="/ylts/zhuanke">查看更多 </router-link>
          </p>
        </div>
        <div class="item">
          <div class="line-one">
            <router-link to="/ylts/tese">
              <p>特色医疗中心</p>
              <p>SPECIALTY MEDICAL CENTER</p>
            </router-link>
          </div>
          <p class="line-two">
            <router-link to="/ylts/tese">查看更多</router-link>
          </p>
        </div>
      </div>
    </section>
    <!-- <div class="container-width x-introduce mt50">
      <div class="title">护理专业发展</div>
      <div class="">
        <ul class="xx1_lb huli">
          <li v-for="(item, index) in huliData" :key="index">
            <a @click="goHuliArticle(item)" :title="item.title">{{
              item.title
            }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
      </div>
    </div> -->

    <FUNCTION></FUNCTION>
    <el-dialog
      :visible.sync="dialogVisible"
      :width="DWIDTH"
      :append-to-body="true"
    >
      <div class="d-body">
        <div class="d-title">{{ dialogContent.name }}</div>
        <div class="d-content">
          <section v-for="(item, index) in dialogContent.children" :key="index">
            <div class="d-department">
              <span @click="gomingyi(item)">[{{ item.name }}]</span>
              <a class="more" @click="gomingyi(item)" title="点击查看相关医生"
                >相关医生>></a
              >
            </div>

            <p v-if="item.description" class="d5">科室简介:</p>
            <div
              v-if="item.description"
              class="d-description multi-ellipsis"
              v-html="item.description"
            ></div>

            <p class="d5" v-if="item.children.length">相关病房:</p>
            <ul>
              <li v-for="(m, n) in item.children" :key="n">
                <a title="点击查看相关医生" @click="gomingyi(m)">
                  {{ m.name }}</a
                >
              </li>
            </ul>
          </section>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import service from "../../service/ylts";
import BANNER from "../../components/banner/ylts";
export default {
  name: "YLTS",
  data() {
    return {
      navigationData: [
        {
          name: "科室介绍",
          path: "/ylts/home",
          width: "31%",
        },
        {
          name: "盛京名医",
          path: "/ylts/mingyi",
          width: "31%",
        },
        {
          name: "国家临床重点专科",
          path: "/ylts/zhuanke",
          width: "38%",
        },
        {
          name: "特色医疗中心",
          path: "/ylts/tese",
        },
        {
          name: "护理专业发展",
          path: "/ylts/huli",
        },
      ],
      currentPath: "/ylts/home",
      list: [],
      dialogVisible: false,
      dialogContent: {},
      huliData: [],
      DWIDTH: "75%",
    };
  },
  components: { BANNER },
  computed: {},
  created() {},
  beforeMount() {},
  methods: {
    gomingyi(e) {
      let articleId = e.id;
      const { href } = this.$router.resolve({
        path: `/ylts/kslist/article/${articleId}`,
      });
      window.open(href, "_self");
    },
    showDialog(e) {
      this.dialogContent = e;
      this.dialogVisible = !this.dialogVisible;
    },
    getHuliData() {
      let parmes = {
        pageIndex: 1,
        pageSize: window.screen.width < 720 ? 6 : 10,
        isshow: 1,
      };
      service.getCareList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.huliData = res.content || [];
      });
    },
    goHuliArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: `/ylts/huli/article`,
          query: {
            id: e.id,
          },
        });
      }
    },
    removeHTMLTag(str) {
      str = str ? str.replace(/<\/?.+?\/?>/g, "") : "";
      return str;
    },
  },
  mounted() {
    service.getKsTree("", (res) => {
      if (res.children.length) {
        res.children.map((item) => {
          if (item.children.length) {
            item.children.map((m) => {
              m.description = this.removeHTMLTag(m.description) || "";
            });
          }
        });
        this.list = res.children || [];
      }
    });
    // 设备宽度小于720px 时 dialog 宽度是 90%
    if (window.screen.width < 720) {
      this.DWIDTH = "90%";
    }
  },
  watch: {},
};
</script>


<style scoped lang="scss">
.title {
  margin-top: 50px;
  font-size: 1.4rem;
  font-weight: bold;
  text-align: center;
}
// 弹出
.d-body {
  width: 100%;
  height: 60vh;
  overflow-y: scroll;
  .d-title {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #333;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .d-content {
    .d-department {
      color: #00479d;
      font-size: 1.4rem;
      cursor: pointer;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
      background: #e5f5ff;
      padding: 5px 20px 5px 20px;
      box-sizing: border-box;
      a {
        color: #666;
        font-size: 0.85rem;
      }
    }
    .d-description {
      color: #333;
      font-size: 1rem;
      line-height: 30px;
      margin-top: 5px;
      padding-left: 20px;
    }
    .d5 {
      color: #00479d;
      padding-left: 20px;
      margin-top: 20px;
    }
    ul {
      display: -webkit-flex;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      padding-left: 20px;
      li {
        width: 25%;
        margin-top: 5px;
        position: relative;
        padding-left: 20px;
        box-sizing: border-box;
        a {
          color: #333;
          font-size: 1rem;
          cursor: pointer;
        }
      }
      li:before {
        content: "";
        position: absolute;
        width: 6px;
        height: 6px;
        background: #00479d;
        border-radius: 50%;
        left: 5px;
        top: 10px;
      }
    }
  }
}

@media only screen and (max-width: 728px) {
  .title {
    margin-top: 20px;
    font-size: 1.4rem;
  }
  .d-body {
    width: 100%;
    height: 60vh;
    overflow-y: scroll;
    .d-title {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      color: #333;
      font-size: 1.6rem;
      font-weight: bold;
      margin-bottom: 30px;
    }
    .d-content {
      .d-department {
        font-size: 0.9rem;
        padding: 5px;
        box-sizing: border-box;
        a {
          color: #666;
          font-size: 0.85rem;
        }
      }
      .d-description {
        color: #333;
        font-size: 0.8rem;
        line-height: 24px;
        margin-top: 5px;
        padding-left: 20px;
      }
      .d5 {
        color: #00479d;
        padding-left: 20px;
        margin-top: 10px;
        font-size: 1rem;
      }
      ul {
        li {
          width: 100%;
          margin-top: 5px;
          padding-left: 10px;
          box-sizing: border-box;
          a {
            color: #333;
            font-size: 0.8rem;
            cursor: pointer;
          }
        }
        li:before {
          content: "";
          position: absolute;
          width: 6px;
          height: 6px;
          background: #00479d;
          border-radius: 50%;
          left: 0px;
          top: 10px;
        }
      }
    }
  }
}
// =================== start========================= //
.medical-treatment {
  width: 100%;
  padding: 20px 0;
  margin-top: 20px;

  .container-width {
    padding: 0 10px;
    height: 125px;
    box-sizing: border-box;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    // height: 200px;
    .item {
      padding: 20px 0px;
      // padding: 20px 25px;
      box-sizing: border-box;
      flex: 1;
      color: #fff;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      box-sizing: border-box;
      cursor: pointer;
      width: 100%;
      .line-one {
        width: 100%;
        p:nth-child(1) {
          letter-spacing: px;
          transition: all 0.2s linear;
          text-align: center;
          width: 85%;
          margin-left: 7.5%;
          text-align: center;
          font-size: 1rem;
          letter-spacing: 3px;
          transition: all 0.2s linear;
          color: #fff;
        }
        p {
          color: #fff;
        }
        p:nth-child(1):hover {
          // letter-spacing: 6px;
        }
        p:nth-child(2) {
          font-size: 12px;
          text-align: center;
          display: none;
        }
      }
      .line-two {
        a {
          color: #fff;
        }
      }
    }
    .item:nth-child(1) {
      background-color: #00479d;
      margin-right: 2%;
    }
    .item:nth-child(2) {
      background-color: #842331;
      margin-right: 2%;
    }
    .item:nth-child(3) {
      background-color: #829c05;
    }
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media only screen and (min-width: 992px) {
  .medical-treatment {
    .container-width {
      height: 160px;
      // height: 200px;
      .item {
        padding: 20px 10px;
        // padding: 20px 25px;

        .line-one {
          p:nth-child(1) {
            font-size: 1.2rem;
            letter-spacing: 3px;
          }
          p:nth-child(1):hover {
            // letter-spacing: 6px;
          }
          p:nth-child(2) {
            font-size: 0.9rem;
            text-align: center;
            display: block;
          }
        }
      }
    }
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media only screen and (min-width: 1200px) {
}

/* 小屏幕（大桌面显示器 大于等于 1330px） */
@media only screen and (min-width: 1330px) {
  .medical-treatment {
    .container-width {
      height: 180px;
      // height: 200px;
      .item {
        padding: 20px 10px;
        // padding: 20px 25px;

        .line-one {
          p:nth-child(1) {
            font-size: 1.4rem;
            letter-spacing: 3px;
          }
          p:nth-child(1):hover {
            // letter-spacing: 6px;
          }
          p:nth-child(2) {
            font-size: 1rem;
            text-align: center;
            display: block;
          }
        }
      }
    }
  }
}

/* 小屏幕（大桌面显示器 大于等于 1900px） */
@media only screen and (min-width: 1900px) {
  .medical-treatment {
    .container-width {
      height: 200px;
      .item {
        padding: 20px 25px;

        .line-one {
          p:nth-child(1) {
            font-size: 1.6rem;
            letter-spacing: 3px;
          }
          p:nth-child(1):hover {
            letter-spacing: 6px;
          }
          p:nth-child(2) {
            font-size: 1rem;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
